import React, { useContext, useState } from 'react';
import { cloneDeep } from 'lodash';
import { assign } from 'xstate';
import { Rating } from '@mui/material';
import { IntlShape } from 'react-intl';

import { SendContext } from '../../SendContext';
import { BaseComponent } from '../Component';
import { MachineContext } from '../../MachineContext';
import { translateWithFallback } from '../../util';
import { theme as evoachDefaultTheme } from '../../theme/theme';
import {EvoachButton} from "../Button";
export interface RatingInputComponent extends BaseComponent {
  type: 'ratingInput';
  props: RatingInputProps;
}
export interface RatingInputProps {
  buttonText: string;
  saveResultTo: string;
}
export const RatingInput: React.FC<RatingInputProps> = ({
  buttonText,
  saveResultTo,
}) => {
  const { send } = useContext(SendContext);
  const [rating, setRating] = useState<number>(0);

  return (
    <div>
      <div>
        <Rating
          value={rating}
          onChange={(evt: any) => setRating(parseInt(evt.target.value))}
          name={Date.now().toString() + 'ratingname'}
          size="large"
          sx={{
            color: evoachDefaultTheme.palette.secondary.main,
            fontSize: '3.2rem',
          }}
        />
      </div>
      <EvoachButton
        onClick={() => {
          send({
            type: 'writeToContext',
            payload: { [saveResultTo]: rating },
          });
          send({
            type: rating === 0 ? 'next' : 'rating' + rating,
          });
        }}
      >
        {buttonText}
      </EvoachButton>
    </div>
  );
};

export const renderRatingInputAction = (intl: IntlShape) => {
  return assign((context: MachineContext, _event, actionMetadata) => {
    const newContext = cloneDeep(context);
    newContext.widgetData = newContext.widgetData.filter(
      (element) => !element.temporary
    );
    const payload = actionMetadata.action.payload;
    newContext.widgetData.push({
      type: 'ratingInput',
      temporary: actionMetadata.action.temporary ?? false,
      props: {
        buttonText: translateWithFallback(intl, payload.buttonText),
        saveResultTo: payload.saveResultTo,
      },
    });
    return newContext;
  });
};
